export const initialState = {
	selectedCustomer: undefined,
	selectedCustomerChangesClone: undefined,
	isSavingEditedCustomer: false,
	isDeletingCustomer: false,
	errorMessageSaveEditedCustomer: undefined
};

export default initialState;
